import React from 'react';
import styled, { keyframes } from 'styled-components';
import Logo from '../assets/images/roundtable-icon.svg'
import Theme from '../Theme';

const Wrapper = styled.div`
    position: fixed;
    z-index: 10000;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100vw;
    background-color: white;
    display: flex;
    justify-content: center;
    align-items: center;
`

const spin = keyframes`
    100% {
        transform: rotate(360deg);
    }
` 


const SpinningLogo = styled.img`
    width: 56px;
    height: 56px;
    margin-bottom: 50px;
    object-fit: contain;
    animation: ${spin} 12s linear infinite;
    ${Theme.breakpoint('md')`
        width: 123px;
        height: 123px;
    `}
    ${Theme.breakpoint('lg')`
        width: 185px;
        height: 185px;
        margin-bottom: 0px;
    `}
`


export default function Loading() {
    const [loaded, setLoaded] = React.useState(false);
    React.useEffect(() => {setLoaded(true)},[])

    return <Wrapper><SpinningLogo loaded={loaded} src={Logo}/></Wrapper>
}
